/**
 * Loads the BSB/KAP chart manifest into the chart-sources store so converted
 * .kap charts appear in the BSB provider with no code change. It loads on
 * startup AND re-fetches whenever the chart provider changes — so if the app was
 * open before the tiles were generated (manifest 404 at startup), simply
 * selecting BSB/KAP re-checks and the charts appear without a manual reload. A
 * fresh clone with no manifest just gets an empty set.
 */
import { useEffect } from 'react';
import { loadBsbManifest } from '@/chart-sources';
import { useChartSourcesStore } from '@/store/chartSources';
import { useChartPlotterStore } from '@/store';

export function BsbManifestLoader() {
  const setBsbCharts = useChartSourcesStore((s) => s.setBsbCharts);
  const chartProviderId = useChartPlotterStore((s) => s.chartProviderId);
  useEffect(() => {
    let live = true;
    loadBsbManifest().then((charts) => {
      if (!live) return;
      const cur = useChartSourcesStore.getState();
      // Set on the first load (even if empty), and on later re-fetches only when
      // it found charts — so a transient failed/empty re-fetch never wipes a
      // good set we already have.
      if (charts.length > 0 || !cur.bsbLoaded) setBsbCharts(charts);
    });
    return () => {
      live = false;
    };
  }, [setBsbCharts, chartProviderId]);
  return null;
}
